import { useAnnouncements } from './useAnnouncements';
import { useBoundaries } from './useBoundaries';
import { useInteractionHandler } from './useInteractionHandler';
import { useInputSelectState } from './useInputSelectState';
import { focusOnInput } from '../utils';
export var useInputSelect = function (_a) {
    var variant = _a.variant, options = _a.options, inputWrapperRef = _a.inputWrapperRef, inputValue = _a.inputValue, _b = _a.minSearchChars, minSearchChars = _b === void 0 ? 1 : _b, _c = _a.maxDisplayedOptions, maxDisplayedOptions = _c === void 0 ? 5 : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d;
    var _e = useInputSelectState({
        variant: variant,
        options: options,
        inputWrapperRef: inputWrapperRef,
        inputValue: inputValue,
        minSearchChars: minSearchChars,
        maxDisplayedOptions: maxDisplayedOptions,
        isLoading: isLoading,
    }), filteredOptions = _e.filteredOptions, showOptions = _e.showOptions, showLoading = _e.showLoading, setShowOptions = _e.setShowOptions, setShowLoading = _e.setShowLoading, isMounted = _e.isMounted;
    var boundaries = useBoundaries({ inputWrapperRef: inputWrapperRef }).boundaries;
    useAnnouncements({
        inputValue: inputValue,
        minSearchChars: minSearchChars,
        filteredOptions: filteredOptions,
        showOptions: showOptions,
        isLoading: isLoading,
    });
    useInteractionHandler({
        inputWrapperRef: inputWrapperRef,
        showLoading: showLoading,
        showOptions: showOptions,
        setShowLoading: setShowLoading,
        setShowOptions: setShowOptions,
    });
    return {
        filteredOptions: filteredOptions,
        boundaries: boundaries,
        showOptions: showOptions,
        showLoading: showLoading,
        setShowOptions: setShowOptions,
        focusOnInput: focusOnInput,
        isMounted: isMounted,
    };
};
//# sourceMappingURL=useInputSelect.js.map